import { render, staticRenderFns } from "./AffaireTotaux.vue?vue&type=template&id=935efebe&"
import script from "./AffaireTotaux.vue?vue&type=script&lang=js&"
export * from "./AffaireTotaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('935efebe')) {
      api.createRecord('935efebe', component.options)
    } else {
      api.reload('935efebe', component.options)
    }
    module.hot.accept("./AffaireTotaux.vue?vue&type=template&id=935efebe&", function () {
      api.rerender('935efebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/avenants_mprinc/components/AffaireTotaux.vue"
export default component.exports